export function setProfiles(data) {
  return {
    type: 'SET_PROFILES',
    payload: data,
  };
};